// src/components/BottomNavBar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUser, FaTrophy, FaHeadset } from 'react-icons/fa';
import './BottomNavBar.css';

const BottomNavBar = () => {
  return (
    <div className="bottom-nav-bar">
      <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
        <FaHome />
        <span>Home</span>
      </NavLink>
      <NavLink to="/profile" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
        <FaUser />
        <span>Profile</span>
      </NavLink>
      <NavLink to="/leaderboard" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
        <FaTrophy />
        <span>Leaderboard</span>
      </NavLink>
      <NavLink to="/customerservice" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
        <FaHeadset />
        <span>Service</span>
      </NavLink>
    </div>
  );
};

export default BottomNavBar;
